import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { FAIcon } from 'reactifi';
import $ from 'jquery';
import i18n from 'lib/utility/i18n';

const FileUploader = (props) => {
  const {
    dataAction,
    dataObjectId,
    dataObjectType,
    id,
    name = 'file_upload_field',
    value,
    buttonType = 'primary',
    buttonText = i18n.t('Select files...'),
    showPlusBtn = true,
    showProgress = true,
    onSuccessState,
    setError,
    contentType,
    acceptExtList = [],
  } = props;

  const [progressPercent, setProgressPercent] = useState(0);
  const [progressText, setProgressText] = useState('');
  const [progressClass, setProgressClass] = useState(null);
  const [progressDisplay, setProgressDisplay] = useState('none');
  const [uploadedFileUrl, setUploadedFileUrl] = useState('');
  const [host, setHost] = useState('');
  const [url, setUrl] = useState('');
  const [formFields, setFormFields] = useState(null);

  const inputRef = useRef(null);

  useEffect(() => {
    mountFileUploader();
  }, [url, formFields, host]);

  const uploaderStart = (e, data) => {
    setProgressText('Loading...');
    setProgressPercent(0);
    setProgressDisplay('block');
    setProgressClass(null);
  };

  const uploaderDone = (e, data) => {
    const key = $(data.jqXHR.responseXML).find('Key').text();
    const url = '//' + host + '/' + key;

    setProgressText('Uploading done.');
    setProgressClass('progress-bar-success');
    setUploadedFileUrl(url);

    if (onSuccessState) {
      onSuccessState(url, data.files?.[0]?.name);
    }
  };

  const uploaderProgress = (e, data) => {
    setProgressPercent(parseInt((data.loaded / data.total) * 100));
  };

  const uploaderFail = (e, data) => {
    let error = ';';
    if (data.jqXHR.responseXML) {
      error =
        data.jqXHR?.responseXML?.getElementsByTagName('Message')[0].textContent;
    } else {
      error = data.jqXHR?.responseText;
    }
    setError(error);
    setProgressClass('progress-bar-danger');
    setProgressText('Failed');
  };

  const mountFileUploader = () => {
    const fileUploader = $(inputRef.current);

    fileUploader.fileupload({
      fileInput: fileUploader,
      url: url,
      type: 'POST',
      autoUpload: false,
      formData: formFields,
      paramName: 'file',
      dataType: 'XML',
      replaceFileInput: false,
      progressall: uploaderProgress,
      start: uploaderStart,
      done: uploaderDone,
      fail: uploaderFail,
      add: addFile,
    });
  };

  const addFile = async (e, data) => {
    const fileExt = data.files[0].name.split('.').pop();
    if (acceptExtList.length) {
      const MIMEtypes = acceptExtList.map((type) => {
        return new RegExp(type.trim().replace('*', '[^\\/,]+'));
      });

      if (!MIMEtypes.some((MIMEtype) => MIMEtype.test(`.${fileExt}`))) {
        setError(i18n.t('Cannot save file: incorrect file type'));
        return;
      }
    } else if (contentType && !contentType.includes(fileExt)) {
      setError(i18n.t('Cannot save file: incorrect file type'));
      return;
    }

    await loadS3Data(fileExt);

    setTimeout(() => {
      data.process().done(function () {
        data.submit();
      });
    });
  };

  const loadS3Data = (ext) => {
    return $.get({
      url: `/admin/media/direct_post_json?aws_content_type=${contentType}&ext=${ext}`,
      success: setS3Data,
      error: (err) => {
        setError(err?.responseJSON?.error);
      },
    });
  };

  const setS3Data = (data) => {
    setUrl(data.url);
    setFormFields(data.formfields);
    setHost(data.host);
  };

  const loadMainButtonCssClass = (buttonType) => {
    return {
      primary: 'btn-primary',
      secondary: 'btn-secondary',
    }[buttonType];
  };

  const mainButtonCssClass = loadMainButtonCssClass(buttonType);

  return (
    <div className="file-upload-element">
      <span className={'btn ' + mainButtonCssClass + ' fileinput-button'}>
        {showPlusBtn && <FAIcon icon="plus" />}
        <span>{buttonText}</span>
        <input
          data-action={dataAction}
          data-object-id={dataObjectId}
          data-object-type={dataObjectType}
          id={id}
          ref={inputRef}
          name={name}
          type="file"
          accept={acceptExtList.join(',')}
        />
      </span>
      <br />
      <br />
      {showProgress && (
        <div className="progress">
          <div
            className={'progress-bar progress-bar-striped ' + progressClass}
            style={{
              width: progressPercent + '%',
              display: progressDisplay,
            }}
          >
            {progressText}
          </div>
        </div>
      )}
      <input type="hidden" name={name} value={uploadedFileUrl || value} />
    </div>
  );
};

FileUploader.propTypes = {
  dataAction: PropTypes.string,
  dataObjectId: PropTypes.string,
  dataObjectType: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  onSuccessState: PropTypes.func,
  value: PropTypes.string,
  contentType: PropTypes.string,
  buttonType: PropTypes.string,
  buttonText: PropTypes.string,
  showPlusBtn: PropTypes.bool,
  showProgress: PropTypes.bool,
  acceptExtList: PropTypes.array,
  setError: PropTypes.func,
};

export default FileUploader;
